$(document).ready(function() {
  // COMMON
  setDateTimePickerListener();

  $('form').on('cocoon:after-insert', function() {
    setDateTimePickerListener();
  });

  if ( $('table#trial-results').length > 0 ) {
    $('.comment-popup').on('click', function(e) {
      e.preventDefault();
      const message = $(this).attr('data-comment');
      const div = $('<div>');
      div.html(message);
      div.dialog({
        title: 'Comments',
        height: 300,
        width: 400,
        autoOpen: true,
        closeOnEscape: false,
        buttons: [ { text: 'OK', click: function() { $(this).dialog( 'close' ); } } ]
      });
    });
  }

  $('input.autocomplete').easyAutocomplete({
    minLength: 2,
    source: '/breeds/autocomplete.json',
  });

  if ( $('.dt-sort-scroll').length > 0 ) {
    $('.dt-sort-scroll').DataTable({
      fixedHeader: true,
      searching: false,
      paging: false,
      scrollY: 300,
      language: { info: '' }
    });
  }

  if ( $('.dt-sort-scroll-searching-paging').length > 0 ) {
    $('.dt-sort-scroll-searching-paging').DataTable({
      fixedHeader: true,
      order: [],
      pageLength: 20,
      lengthChange: false,
      scrollY: 500
    });
  }

  if ( $('.dt-sort-searching-paging').length > 0 ) {
    $('.dt-sort-searching-paging').DataTable({
      fixedHeader: true,
      order: [],
      pageLength: 20,
      lengthChange: true,
    });
  }

  if ( $('.dt-sort-searching-paging-pagelength').length > 0 ) {
    $('.dt-sort-searching-paging-pagelength').DataTable({
      fixedHeader: true,
      pageLength: 20
    });
  }

  if ( $('input#use_organization_address').length > 0 ) {
    $('input#use_organization_address').on('click', function() {
      const organization_id = $('select#trial_organization_id option:selected').val();
      const remit_to_name = $('input#trial_remit_to_name');
      const remit_to_street = $('input#trial_remit_to_street');
      const remit_to_city = $('input#trial_remit_to_city');
      const remit_to_state = $('input#trial_remit_to_state');
      const remit_to_zip = $('input#trial_remit_to_zip');
      if ( $('input#use_organization_address').is(':checked') ) {
        if (organization_id.length > 0) {
          $.ajax({
            url: '/admin/organizations/' + organization_id + '/remit_to',
            dataType: 'json',
            success: function(data) {
              remit_to_name.val(data.name);
              remit_to_street.val(data.street);
              remit_to_city.val(data.city);
              remit_to_state.val(data.state);
              remit_to_zip.val(data.zip);
            }
          });
        }
      } else {
        remit_to_name.val('');
        remit_to_street.val('');
        remit_to_city.val('');
        remit_to_state.val('');
        remit_to_zip.val('');
      }
    });
  }

  $('.best_in_place').best_in_place();

  // OWNER DASHBOARD
  $('#owner-dashboard a').click(function (e) {
        e.preventDefault()
        $(this).tab('show')
  });

  // ORDER FORM
  $('#billing-information-same-as-account').change(
    function() {
      if ($(this).is(':checked')) {
        $('#unpopulated-billing-information').hide();
        $('#populated-billing-information').show();
      }
      else {
        $('#unpopulated-billing-information').show();
        $('#populated-billing-information').hide();
      }
    }
  );

  // ADMIN - OWNERS CARTS
  $(document).on('change', '.trial-id-select', function(e) {
    const trial_id = $(e.target).val();
    const dom_id = $(e.currentTarget).attr('id');

    $.ajax({
      url: '/admin/trials/' + trial_id + '/trial_classes',
      data: 'dom_id=' + dom_id
    });
  });
});

function setDateTimePickerListener() {
  $('input.datetimepicker').flatpickr({
    allowInput: true,
    enableTime: true,
    dateFormat: 'h:i K m/d/Y',
    minuteIncrement: 15
  });
  $('input.datepicker').flatpickr({
    allowInput: true,
    dateFormat: 'm/d/Y'
  });
  $('input.timepicker').flatpickr({
    enableDate: false,
    enableTime: true,
    format: 'h:i K',
    minuteIncrement: 15
  });
}
